import { useLang } from "../i18n";
import { Globe } from "lucide-react";

export const LanguageSwitcher = () => {
  const { lang, setLang } = useLang();
  return (
    <div
      className="inline-flex items-center gap-1 rounded-full border border-[#26422A]/50 bg-[#FFFFFF] p-1 shadow-sm"
      data-testid="language-switcher"
    >
      <Globe className="ml-1.5 h-4 w-4 text-[#26422A]" />
      <button
        data-testid="lang-en-btn"
        onClick={() => setLang("en")}
        className={`rounded-full px-3 py-1 text-sm font-bold transition-colors ${
          lang === "en" ? "bg-[#26422A] text-[#FFEEBC]" : "text-[#26422A]/70 hover:text-[#26422A]"
        }`}
      >
        EN
      </button>
      <button
        data-testid="lang-tr-btn"
        onClick={() => setLang("tr")}
        className={`rounded-full px-3 py-1 text-sm font-bold transition-colors ${
          lang === "tr" ? "bg-[#26422A] text-[#FFEEBC]" : "text-[#26422A]/70 hover:text-[#26422A]"
        }`}
      >
        TR
      </button>
    </div>
  );
};
